import installer from './install';

export * from './components';

export * from './utils/globalType';

export const { install } = installer;

export default installer;

// import components from './components';
// import type { App, Plugin } from 'vue';

// export * from './components';

// // console.log(Grid.Row.props);

// const install = (app: App) => {
//   Object.keys(components).forEach((key) => {
//     const component = (components as Record<string, any>)[key];
//     if (component.install) {
//       app.use(component);
//     }
//   });

//   // app.config.globalProperties.$message = components.message;
//   // app.config.globalProperties.$notice = components.notice;
//   // app.config.globalProperties.$modal = components.Modal;
//   // app.config.globalProperties.$info = components.Modal.info;
//   // app.config.globalProperties.$success = components.Modal.$success;
//   // app.config.globalProperties.$error = components.Modal.error;
//   // app.config.globalProperties.$warn = components.Modal.warn;
//   // app.config.globalProperties.$confirm = components.Modal.confirm;
//   // app.config.globalProperties.$destroyAll = components.Modal.destroyAll;
//   return app;
// };

// export default {
//   install
// } as Plugin;
